<template>
  <main class="main" role="main">
    <div class="main_top">
      <div class="top_ttl">검색으로 찾기</div>
      <label class="search" style="margin-bottom: 1.6rem;">
        <input
          type="search"
          v-model="searchText"
          placeholder="동, 읍, 면 단위로 검색"
          @keyup.enter="getRegionByName"
        />
        <button class="i_search" @click="getRegionByName"></button>
      </label>
      <div
        @click="getCurrentRegion"
        style="align-items: center;justify-content: center;display:flex;"
        :style="
          geolocationAvailable === true
            ? 'font-size: 1.3rem;\n' + 'font-weight: 700;\n' + 'color: #6699ff;'
            : 'color: #6699ff;\n' + 'font-size: 1.3rem;\n' + 'cursor: default;'
        "
      >
        <!-- <img
          v-if="geolocationAvailable === false"
          :src="require('@/assets/front/images/new/i_location_input_gray.svg')"
          style="width:1.8rem;height:1.8rem;margin-right:0.4rem;"
          alt=""
        /> -->
        <img
          :src="require('@/assets/front/images/v2/icons/i_location_input.svg')"
          style="width:1.8rem;height:1.8rem;margin-right:0.4rem;"
          alt=""
        />
        현재 위치 불러오기
      </div>
      <div class="top_divider"></div>
      <!-- <div class="top_ttl">현재 위치로 찾기</div>
      <button
        class="btn"
        :style="
          geolocationAvailable === true
            ? '    padding: 0 1rem;\n' +
              '    height: 4rem;\n' +
              '    border: 1px solid #50D3B4;\n' +
              '    border-radius: 2rem;\n' +
              '    background-color: #50D3B4;\n' +
              '    font-size: 1.3rem;\n' +
              '    font-weight: 700;\n' +
              '    color: #fff;\n' +
              '    word-break: keep-all;\n' +
              '    line-height: 1.2;'
            : '    border-color: #BDBDBD;\n' +
              '    background-color: #BDBDBD;\n' +
              '    color: #fff;\n' +
              '    cursor: default;'
        "
        @click="getCurrentRegion"
      >
        위치 불러오기
      </button> -->
    </div>
    <div class="main_con">
      <div v-if="showCurrentRegion">
        <div class="location_list" v-if="myArea.nearby.length">
          <div class="location_ttl">우리동네</div>
          <ul>
            <li>
              <div
                role="button"
                @click="selectRegion(myArea.current, fromPage)"
              >
                {{ myArea.current.name }}
              </div>
            </li>
          </ul>
          <div class="location_ttl">근처동네</div>
          <ul>
            <li v-for="(item, index) in myArea.nearby" v-bind:key="index">
              <div role="button" @click="selectRegion(item, fromPage)">
                {{ item.name }}
              </div>
            </li>
          </ul>
        </div>
        <div class="empty_wrap" v-if="myArea.nearby.length == 0">
          <div class="empty result">
            <!--'기본: ', '준비중: ready', '결과없음: result'-->
            <div class="msg">
              <div>현재 위치로 정보를 받아오지 못했습니다.</div>
              <div>우리동네 이름으로 검색해보세요.</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showSearchResult">
        <div class="location_list" v-if="area.count">
          <div class="location_ttl">검색결과</div>
          <ul>
            <ul>
              <li v-for="(item, index) in area.content" v-bind:key="index">
                <div role="button" @click="selectRegion(item, fromPage)">
                  {{ item.name }}
                </div>
              </li>
            </ul>
          </ul>
        </div>
        <div class="empty_wrap" v-if="area.count == 0">
          <div class="empty result">
            <!--'기본: ', '준비중: ready', '결과없음: result'-->
            <div class="msg">
              <div>검색하신 동네가 없습니다.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <GPSUseConfirmModal
      v-if="gpsUseModal"
      @close="hideGpsUseModal"
      @setting="openSetting"
    ></GPSUseConfirmModal>
    <GPSOffModal
      v-if="gpsOffModal"
      @close="hideGpsOffModal"
      @setting="openSetting"
    ></GPSOffModal>
  </main>
</template>

<script>
import GPSUseConfirmModal from '@/front/customer/views/auth/modal/GPSUseConfirmModal';
import GPSOffModal from '@/front/customer/views/auth/modal/GPSOffModal';
import { mapActions, mapState, mapGetters } from '@common/store/modules/area';
import * as actions from '@common/store/modules/area/types';
import * as getters from '@common/store/modules/area/getters';
import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import {
  isApp,
  sleep,
  clearLocation,
  nativeLocation,
  nativeGoToSetting,
} from '@common/lib/common/utils';

export default {
  components: { GPSOffModal, GPSUseConfirmModal },
  data() {
    return {
      fromPage: 'Auth',
      isAreaValue: '',
      lat: 0,
      lng: 0,
      searchText: '',
      showSearchResult: false,
      showCurrentRegion: false,
      geolocationAvailable: false,
      gpsUseModal: false,
      gpsOffModal: false,
      checkerId: -1,
    };
  },
  async created() {
    this.fromPage = this.$route.query.from;
    this.isAreaValue = this.$route.query.isAreaValue;
    await this.handleRefresh();
  },
  beforeDestroy() {
    if (this.checkerId !== -1) {
      clearInterval(this.checkerId);
      this.checkerId = -1;
    }
  },
  computed: {
    ...mapGetters({
      myArea: getters.MY_AREA,
      area: getters.AREA,
    }),
  },
  methods: {
    ...mapActions([
      actions.FETCH_CURRENT,
      actions.FETCH_DONG,
      actions.AREA_RESET_STATE,
    ]),
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    async getRegionByName() {
      this[actions.AREA_RESET_STATE]();
      this.showCurrentRegion = false;
      this.showSearchResult = true;
      const param = {
        keyword: this.searchText,
      };
      if (param.keyword) {
        await this[actions.FETCH_DONG](param);
      }
    },
    async getCurrentRegion() {
      await this.handleRefresh();
      if (this.geolocationAvailable) {
        this[actions.AREA_RESET_STATE]();
        this.showSearchResult = false;
        this.showCurrentRegion = true;
        const param = {
          distance: 2000,
          latitude: this.lat,
          longitude: this.lng,
        };
        await this[actions.FETCH_CURRENT](param);
      }
    },

    selectRegion(area, fromPage) {
      const { id, name, emd_name, codeType } = area;
      this.$router.push({
        name: 'Auth.RegionSelected',
        query: {
          areaName: emd_name,
          areaFullName: name,
          areaId: id,
          codeType: codeType,
          from: fromPage,
          isAreaValue: this.isAreaValue,
        },
      });
    },

    async handleRefresh() {
      if (!isApp()) {
        if (this.$geolocation.checkSupport()) {
          const currentPosition = await this.$geolocation.getCurrentPosition();
          if (currentPosition) {
            console.log(currentPosition);
            this.lat = currentPosition.coords.latitude;
            this.lng = currentPosition.coords.longitude;
            this.geolocationAvailable = true;
          }
        }
      } else {
        clearLocation();
        nativeLocation();
        await sleep(1000);
        //alert('location.code: ' + window.$bridge.location.code);
        if (window.$bridge.location.code !== undefined) {
          // GPS 켜져있을때 : 1, 꺼져있을 때 -1
          if (window.$bridge.location.code === '1') {
            //alert('a1');
            this.hideGpsOffModal();
            this.hideGpsUseModal();
            this.lat = window.$bridge.location.latitude;
            this.lng = window.$bridge.location.longitude;
            this.geolocationAvailable = true;
          } else {
            //alert('a2');
            /*this[commonActions.SET_DIALOG]({
              type: 'normal',
              icon: 'warning',
              //title: this.$t('common.confirm'),
              message: `GPS가 꺼져있습니다.`,
              okCb: async () => {
                this[commonActions.HIDE_DIALOG]();
              },
            });*/

            this.showGpsOffModal();
          }
        } else {
          //alert('a3');
          /*this[commonActions.SET_DIALOG]({
            type: 'normal',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message: '위치 권한이 없습니다.',
            okCb: async () => {
              this[commonActions.HIDE_DIALOG]();
            },
          });*/
          this.showGpsUseModal();
        }
      }
    },
    startChecker() {
      if (this.checkerId === -1) {
        this.checkerId = setInterval(() => {
          //alert('checker ' + window.$bridge.location.permissionCode);
          try {
            if (window.$bridge.location.permissionCode === '1') {
              this.hideGpsOffModal();
              this.hideGpsUseModal();
            }
          } catch (e) {
            //alert(e);
          }
        }, 1000);
      }
    },
    hideGpsUseModal() {
      this.gpsUseModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    hideGpsOffModal() {
      this.gpsOffModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    showGpsUseModal() {
      this.gpsUseModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    showGpsOffModal() {
      this.gpsOffModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    openSetting() {
      if (!isApp()) {
        this.getLocation();
      } else {
        // 네이티브 앱 위치설정 열기
        nativeGoToSetting(2);
      }
    },
  },
};
</script>
